import { Button, Stepper, TextField, Typography } from "@mui/material";
import { StepperNotesProps } from "../../Utils/Types";
import DisplayOneNote from "./DisplayOneNote";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useEffect, useState } from "react";
import { NoteModel } from "../../Utils/Models";
import styles from "../../Styles/stepper.module.css";
import { Add } from "@mui/icons-material";
import { postData } from "../../Services/postData";
import { endpoints } from "../../Utils/UrlEnum";
import { useParams } from "react-router-dom";

export default function StepperNotes(props: StepperNotesProps) {
  const [note, setNote] = useState(new NoteModel());
  const [shouldSubmit, setShouldSubmit] = useState(false);
  const { notes, updateNotes, disabled } = props;
  const userId = localStorage.getItem("userId");
  const { id } = useParams();
  const [localNotes, setLocalNotes] = useState<any[]>(notes);

  // Whenever notes prop changes, sync localNotes
  useEffect(() => {
    setLocalNotes(notes);
  }, [notes]);

  /**
   *
   */
  useEffect(() => {
    if (shouldSubmit && note && note.text !== "") {
      //create copy of notes array
      const newNotes = [...localNotes];
      //if note has no agent, set agent to userId
      if (!note.agent) note.agent = userId;
      //find note in notes array by _id and update it
      //or add new note to notes array
      const index = newNotes?.findIndex((n: NoteModel) => n._id === note._id);
      if (index !== -1) {
        newNotes[index] = note;
        updateNotes(newNotes);
      } else {
        newNotes.push(note);
        updateNotes(newNotes);
      }
      setShouldSubmit(false);
    }
  }, [shouldSubmit]);

  const submitTheNewNote = (newNote: any) => {
    const newNotes = [...localNotes];
    newNotes.push(newNote);
    updateNotes(newNotes);
  };

  /**
   *
   * @param note
   */
  const deleteContactNote = (note: NoteModel) => {
    //find note in notes array by _id and delete it
    const newNotes = notes?.filter((n: NoteModel) => n._id !== note._id);
    updateNotes(newNotes);
  };

  const saveNote = () => {
    //save the new note
    postData(`${endpoints.updateOrderNotes}/${id}`, note).then((response) => {
      if (response && response.data) {
        submitTheNewNote(response.data);
        setNote(new NoteModel());
      }
    });
  };
  return (
    <div>
      <Stepper
        orientation="vertical"
        style={{ maxHeight: 500, overflowY: "scroll", padding: 10 }}
      >
        {localNotes?.map((note: any, index: number) => {
          return (
            <DisplayOneNote
              disabled={disabled}
              note={note}
              key={note?._id}
              handleEdit={(note: NoteModel) => {
                setNote(note);
              }}
              handleDelete={(note: NoteModel) => {
                deleteContactNote(note);
              }}
            />
          );
        })}
      </Stepper>
      <div style={{ padding: 20, gap: "2px" }}>
        <>
          <Typography variant="h6">{Vocabulary.addMessageToTeam}</Typography>
          <TextField
            value={note.text}
            multiline
            rows={4}
            style={{ width: "70%" }}
            onChange={(e) => {
              if (e.target.value != "")
                setNote({ ...note, text: e.target.value });
            }}
          />
        </>
        <Button
          disabled={disabled}
          className={styles.addButton}
          variant="contained"
          color="secondary"
          onClick={saveNote}
          startIcon={<Add fontSize="small" />}
          style={{ marginLeft: 10 }}
        >
          {Vocabulary.save}
        </Button>
      </div>
    </div>
  );
}
